<template>
  <v-form-create v-bind:name="name" v-bind:top_title="top_title" large>
    <slot />

    <v-row v-if="noPartiation">
      <v-col cols="12" sm="6">
        <v-text-field
          v-if="!noNote"
          v-model="note"
          :label="$t('note')"
          counter="500"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-if="noPartiation"
          v-model="partiation_no"
          :label="$t('partiation_no')"
          counter="50"
        />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-text-field
      class="ml-4 mr-3"
        v-if="!noNote"
        v-model="note"
        :label="$t('note')"
        counter="500"
      />
    </v-row>
    <template v-slot:footer>
      <v-toolbar flat>
        <v-toolbar-title>
          {{ $t("items") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <slot name="count_headers" />
        <slot name="add_items_by_supplier" />
      </v-toolbar>
      <v-divider />
      <slot name="items" />

      <v-data-table
        v-if="additional_costs.length > 0 && !noAdditionalCost"
        v-bind:headers="additional_cost_headers"
        v-bind:items="additional_costs"
        :items-per-page="200000"
        hide-default-footer
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-text-field
            v-model="item.name"
            :ref="'additional_cost_name' + item.index"
            :rules="[fieldRules.require]"
          />
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          <vuetify-money
            v-model.number="item.amount"
            class="right"
            :ref="'additional_cost_amount' + item.index"
            :rules="[fieldRules.require]"
            v-bind:options="
              item.amount_currency == 'usd' ? moneyOptionsUSD : moneyOptions
            "
          />
        </template>
        <template v-slot:[`item.amount_currency`]="{ item }">
          <v-select v-model="item.amount_currency" :items="currencies">
          </v-select>
        </template>
        <template v-slot:[`item.remove`]="{ item }">
          <v-btn icon v-on:click="remove_additional_cost(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <v-card-text v-if="!noAdditionalCost">
        <v-btn
          color="#success"
          text
          outlined
          v-on:click="add_additional_cost"
          >{{ $t("add_additional_cost") }}</v-btn
        >
      </v-card-text>
      <template v-if="total">
        <v-divider />
        <v-card-text>
          <v-layout row>
            <v-flex md4 offset-md6 class="text-right font-weight-bold mt-2"
              >{{ $t("total") }}: {{ total.toLocaleString() }}</v-flex
            >
            <v-flex md2 class="ma-0 pa-0 px-4">
              <v-select
                v-model="total_currency"
                class="ma-0 pa-0 mx-4"
                :items="currencies"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider />
      </template>
    </template>
    <template v-slot:action>
      <slot name="action" />
    </template>
  </v-form-create>
</template>
<script>
export default {
  props: {
    name: String,
    top_title: String,
    noAdditionalCost: { type: Boolean, default: false },
    total: Number,
    noNote: Boolean,
    noPartiation: Boolean,
  },
  data: () => ({
    additional_costs: [],
    total_currency: "uzs",
    additional_cost_headers: [
      { text: "Additional cost", value: "name" },
      { text: null, width: 250 },
      { text: "Amount", value: "amount", align: "right", width: 100 },
      {
        text: "Currency",
        value: "amount_currency",
        align: "center",
        width: 100,
      },
      { text: null, value: "remove", align: "center", width: 50 },
    ],
    note: null,
    partiation_no: "",
  }),
  mounted() {
    for (const index in this.additional_cost_headers) {
      this.additional_cost_headers[index]["sortable"] = false;
    }
  },
  watch: {
    total_currency() {
      this.$emit("set-total-amount-currency", this.total_currency);
    },
  },
  methods: {
    options() {
      var options = {
        notes: this.note,
        partiation_no: this.partiation_no,
      };
      if (!this.noAdditionalCost) {
        options["additional_cost"] = this.additional_costs;
        options["total_currency"] = this.total_currency;
      }
      return options;
    },
    init(options) {
      this.note = options.notes;
      this.partiation_no = options.partiation_no;
      if (!this.noAdditionalCost) {
        this.additional_costs = options.additional_cost;
      }
    },
    add_additional_cost() {
      let index = 1;
      if (this.additional_costs[this.additional_costs.length - 1]) {
        index = this.additional_costs[this.additional_costs.length - 1].index;
      }
      this.additional_costs.push({
        index: index,
        name: null,
        amount_currency: "uzs",
        amount: null,
      });
    },
    remove_additional_cost(item) {
      const index = this.additional_costs.indexOf(item);
      this.additional_costs.splice(index, 1);
    },
  },
  computed: {
    target() {
      return this.$route.params["target"];
    },
  },
};
</script>
